import React, { useEffect, useState } from 'react';

export function useMinuteCheck(date) {
  const now = Date.now();
  const diff = now - new Date(date).getTime();
  const minutesInSeconds = 5 * 60 * 1000;
  
  return diff > minutesInSeconds;
}

function hasPassed(currentTime, loadTime, minutesInSeconds){
  return (currentTime - loadTime) / 1000 >= minutesInSeconds
}